module.exports = __webpack_public_path__ + "img/FPS.903d3587.png";